export default "__VITE_ASSET__cecfecb0__"